import type {SVGProps} from 'react';

import Icon from './Icon';

const InfoIcon = (props: SVGProps<SVGSVGElement>) => {
    return (
        <Icon width='24' height='24' viewBox='0 0 24 24' fill='none' {...props}>
            <circle cx='12' cy='12.4824' r='8.25' className='stroke-primary dark:stroke-secondary' strokeWidth='1.5' />
            <circle cx='12' cy='8.35742' r='0.75' className='fill-primary dark:fill-secondary' />
            <rect
                x='11.25'
                y='10.0107'
                width='1.5'
                height='7.425'
                rx='0.75'
                className='fill-primary dark:fill-secondary'
            />
        </Icon>
    );
};

export default InfoIcon;
